<template>
  <div class="racontrols">
    <GwMenu class="text-noselect">
      <template #opener>
        <div
          class="icon_btn text-medium mdi mdi-filter csst"
          style="padding: 0.25rem"
          data-tst="racontrols_saved_filters"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
        >
          <div
            class="csst_content"
            style="position: fixed"
            v-html="$t('tabs.filters')"
          ></div>
        </div>
      </template>
      <template #default="{ methods }">
        <div class="gw_menu">
          <ReportsFlopFilter
            v-if="street === 'flop'"
            :savedFiltersInside="true"
            data-tst="reports_flop_filter_menu"
            @click:save="methods.toggleOpen(false)"
          />
          <ReportsTurnFilter
            v-else-if="street === 'turn'"
            :instaApply="true"
            :flopBoard
            :turnFilterHand
          />
        </div>
      </template>
    </GwMenu>

    <GwSavedFiltersMenu
      v-if="street === 'flop'"
      class="ml-1"
      filterUrlPrefix="ffrf"
      filterConfigKey="reportsFlopFilter"
      :hasUrlUpdate="false"
    >
      <template #opener>
        <div
          class="icon_btn mdi text-medium mdi-folder csst csst_nm"
          style="padding: 0.25rem"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
        >
          <div
            class="csst_content"
            style="position: fixed"
            v-html="$t('common.saved_filters')"
          ></div>
        </div>
      </template>
    </GwSavedFiltersMenu>
  </div>
</template>

<script>
import ReportsFlopFilter from '@/components/DataTables/Filters/ReportsFlopFilter'
import ReportsTurnFilter from '@/components/DataTables/Filters/ReportsTurnFilter'
import GwMenu from '@/components/lib/GwMenu'
import GwSavedFiltersMenu from '@/components/DataTables/v2/GwSavedFiltersMenu'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'StudyControlsReports',
  components: {
    ReportsFlopFilter,
    ReportsTurnFilter,
    GwMenu,
    GwSavedFiltersMenu,
  },
  mixins: [float_mix],
  props: {
    street: { default: () => 'flop' },
    flopBoard: String,
    turnFilterHand: String,
  },
}
</script>
<style lang="scss" scoped>
.racontrols {
  display: flex;
  // gap: 0.25rem;
  padding: 0 0.25rem;
  background: var(--clr-black-1);
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  max-height: 1.65rem;
}
</style>
